import { useCurrentUser } from '../auth/useCurrentUser';

/**
 * Prod-option gating (decisions §8) for env-name LISTS — the shared filter
 * behind every "which envs are visible/targetable" site that isn't already
 * downstream of `EnvContext.availableEnvs` (which filters itself, see
 * `EnvContext.tsx`): the per-env version fan-out (`useTenantVersions`) and
 * the promotion pages' read-only ladder display.
 *
 * Flag off: NEVER filters — today none of these list sites gate prod at all
 * (only the Deploy button / Promote submit do, via `hasPermission`
 * ('prod_option') directly at the two actual write sites, DeployMatrix and
 * PromoteToEnvModal). Flag on: drops `'prod'` unless the user holds
 * `prod_option` (super-admin passes via `hasPermission`'s own bypass).
 */
export function useVisibleLadderEnvs(envs: string[]): string[] {
  const { rbacV2Enabled, hasPermission } = useCurrentUser();
  if (!rbacV2Enabled || hasPermission('prod_option')) return envs;
  return envs.filter((env) => env !== 'prod');
}
